import Plugin from "@ckeditor/ckeditor5-core/src/plugin"
import ButtonView from "@ckeditor/ckeditor5-ui/src/button/buttonview"

export default class TableOfContentsBoxUI extends Plugin {
  init() {
    const editor = this.editor
    const t = editor.t

    editor.ui.componentFactory.add("tableOfContentsBox", (locale) => {
      const command = editor.commands.get("insertTableOfContentsBox")

      const buttonView = new ButtonView(locale)

      buttonView.set({
        label: t("目次用見出し"),
        withText: true,
      })

      buttonView.bind("isOn", "isEnabled").to(command, "value", "isEnabled")

      this.listenTo(buttonView, "execute", () =>
        editor.execute("insertTableOfContentsBox")
      )

      return buttonView
    })
  }
}
